<template>
      <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Topnav -->
    <!-- <Header /> -->
    <!-- Header -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-2 col-2">
              <h2>History</h2>
            </div>
          </div>
          <!-- Card stats -->
        </div>
        <div class="filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
              <div class="d-flex justify-content-between">
                <h5 class="ml-3">Filters</h5>
                <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                </span>
              </div>
              <div class="row" v-if="showFilters">
                <div class="col-lg-12">
                  <form class="row">
                  <div class="col-md-2">
                    <label for="filter" class="col-form-label">From</label>
                    <datepicker 
                    v-model="fromDate"  
                    name="fromDate" 
                    format="MM/dd/yyyy" 
                    :clear-button="true" 
                    :calendar-button="true" 
                    :disabledDates="disabledDates"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-2">
                    <label for="filter" class="col-form-label">TO</label>
                    <datepicker  
                    v-model="toDate"  
                    name="toDate" 
                    format="MM/dd/yyyy" 
                    :clear-button="true" 
                    :calendar-button="true" 
                    :disabledDates="disabledDates"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                   <div class="col-md-2" style="top:12px">
                    <!-- <button @click="clearFilter()" type="button" class="btn btn-secondary rounded ml-0">Clear</button> -->
                    <button @click="getBidList()" type="button" class="btn btn-primary rounded ml-0">Filter</button>
                   </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    
    <div class="container-fluid mt--6">
      <div class="row xsOnly">
        <div class="col-xl-12">
          
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                      @click="sort('cusip')">CUSIP/COUPON</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                      @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                      @click="sort('state')">STATE/<br>INSURER</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'amount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'amount'  ? 'sort-desc' : '']"  
                      @click="sort('amount')">BID PRICE</th>
                      <!-- <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tmcPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tmcPrice'  ? 'sort-desc' : '']"  
                      @click="sort('tmcPrice')">TMC PRICE</th> -->
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                      @click="sort('quantity')">PAR <br> VALUE</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                      @click="sort('minQuantity')">MINIMUM <br> QUANTITY</th>
                     <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidKeepCancel'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidKeepCancel'  ? 'sort-desc' : '']"  
                      @click="sort('bidKeepCancel')">MINIMUM QUANTITY <br> BID OPTION</th>  
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidValidity'  ? 'sort-desc' : '']"  
                      @click="sort('bidValidity')"># OF DAYS</th>
                    <!-- <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'pointToDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'pointToDate'  ? 'sort-desc' : '']"  
                      @click="sort('pointToDate')">POINT TO</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                      @click="sort('curveYield')">CURVE<br>YIELD</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                      @click="sort('yieldSpread')">YIELD <br> SPREAD </th>
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                      @click="sort('minBps')">BPS RANGE <br> MIN/MAX </th>
                   
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'factorRatio'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'factorRatio'  ? 'sort-desc' : '']"  
                      @click="sort('factorRatio')">FACTOR <br> RATIO</th> -->
                    <th 
                      v-if="isAdmin" 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderName'  ? 'sort-desc' : '']"  
                      @click="sort('traderName')">TRADER </th>
                    <th scope="col" class=" text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody class="list">
                   <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="bid in bids" :key="bid.id" @click="getBidDetails(bid)" v-bind:class="{'active-row': bid.isActive}">
                      <td>
                        <span class="cusips">{{bid.cusipVal}}</span>
                        <span class="coupon">{{bid.cusipCoupon |  percent(3) }}</span>
                        <!-- <span class="desc">{{bid.cusipDescription}}</span> -->
                      </td>
                      <td class="text-center">
                        <span class="maturity">{{moment(bid.cusipMaturityDate).format("MM/DD/YYYY")}}</span><br>
                        {{bid.cusipCallDate ? moment(bid.cusipCallDate).format("MM/DD/YYYY") : "N/A"}}
                      </td>
                      <td>
                        <span class="state">{{getStateName(bid.cusipStateId)}}</span>
                        <span class="insurer">{{bid.cusipBondInsurer ? bid.cusipBondInsurer : "N/A"}}</span>
                      </td>
                      <td> 
                        <span class="text-primary">{{bid.amount | currency}}</span>
                        <!-- <input :disabled="bid.status != 'NEW'" v-if="bid.bidType != 'YIELD'"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="bid.amount"> -->
                      
                      <td class="text-center">{{bid.quantity}}</td>
                      <td class="text-center">{{bid.minQuantity}}</td>
                      <td class="text-center">
                        <span>{{bid.bidKeepCancel ? bid.bidKeepCancel : "N/A"}}</span>
                      </td>
                      <td v-on:click.stop.prevent="">
                          {{bid.bidValidity}}
                        <!-- <select :disabled="bid.status != 'NEW'" class="form-control number" id="exampleFormControlSelect1"  v-model="bid.bidValidity">
                            <option
                              v-for="validity in bidValidity"
                              :key="validity"
                            >{{validity}}</option>
                        </select>                   -->
                      </td>
                      <!-- <td class="text-center">
                        <span v-if="bid.bidType == 'YIELD'" class="bid text-success">{{bid.pointToDate}} </span>
                        <span v-if="bid.bidType == 'YIELD'" class="bid text-primary">{{bid.pointToCurve}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'">{{bid.curveYield}}</span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>

                      </td>
                      <td 
                        class="text-center"><span v-if="bid.bidType == 'YIELD'">{{bid.yieldSpread}}</span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>

                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'"> MIN {{bid.minBps ? bid.minBps : 0}} / MAX {{bid.maxBps ?  bid.maxBps : 0}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'"> 1 : {{bid.factorRatio || 0}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td> -->
                      <td 
                        v-if="isAdmin" 
                        class="text-center" 
                        @click="getTraderInfo(bid.cognitoSub)">{{bid.traderName}}
                      </td>
                      <td class="text-center" > 
                        <span style="float:left">
                          <button @click="checkOutstandingBid(bid);" v-on:click.stop.prevent="" type="button"  class="btn btn-success btn-sm my-2">
                            <i class="fas fa-upload"></i> REUPLOAD</button>
                          </span>
                      </td>
                    </tr>
                </tbody>
              </table>
               <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getBidList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <trader-info v-bind:traderInfo="traderData" v-if="modalOpen" @close="modalOpen = false"></trader-info>
      <out-standing-bid-exist
        v-bind:outStandingBid="outStandingBid"
        v-bind:selectedCusip="selectedBid"
        @close="outStandingBid = null"
        @create="cancelBidAndPlaceNewBid()"
        v-if="outStandingBid"
        >
      </out-standing-bid-exist>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import TraderInfo from "./TraderInfoPopup"
import stateConstants from "@/stateConstants";
import Datepicker from 'vuejs-datepicker';
import OutStandingBidExist from "../trader/bid/OutstandingBidExistPopup"

export default {
  name: "outstandingbid",
   components: {
    // Header,
    // Footer,
    TraderInfo,
    Datepicker,
    OutStandingBidExist
  },
  data() {
    return {
      accessToken: null,
      bids:[],
      //bids: [{"isActive":false,"id":1106,"cusipVal":"10608MHW9","maturityDate":"2039-09-01T00:00:00.000+0000","bondInsurer":"BUILD AMERICA MUTUAL","traderName":"Arun Reghu","state":"Texas","purpose":"Gen purp/ pub impt","description":"BRAZORIA CNTY TEX MUN UTIL DIST NO 55 02.37500% 09/01/2039 UNLTD TAX BDS SER. 2020","status":"ACTIVE"}],
      bidstoCancel : [],
      selectedBid : {},
      config: config,
      loading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 1,
      isSelectAll : false,
      sortColumn: "latestDate",
      sortOrder: "DESC",
      traderData:{},
      modalOpen: false,
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      cognitoSub : null,
      allYieldValue : "",
      allBidValue : "",
      allYieldValueOperator : "+",
      allBidValueOperator : "+",
      yieldValue : "",
      yieldValueOperator : "+",
      bidValidity : 3,
      stateConstants: stateConstants,
      bidSelected : null,
      outStandingBid : null,
      showFilters : false,
      traderList : [],
      filterTrader : null,
      fromDate : "",
      toDate : "",
      disabledDates: {
        from : this.getDisabledDate()
      },
    };
  },
  methods: {
    getDisabledDate(){
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow;
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getTraderInfo(cognitoSub){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            cognitoSub,
            auth
        )
        .then(result => {
          this.modalOpen = true;
          this.traderData = result.data;
          this.loading = false;

        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    searchBid(){
      this.getBidList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getBidList(); 
    },
    selectAllBids(event){
      this.bids.forEach(function(bid) {
        bid.isCancel = event.target.checked;
      });
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getBidList();
    },
    getBidList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken()  }
      };
      var subId = (!this.isAdmin && this.isTrader) ? this.cognitoSub : "";
      var userId = this.filterTrader ? this.filterTrader.id : "";
      var fDate = this.fromDate ? this.moment(this.fromDate).format("YYYY-MM-DD") : "";
      var tDate = this.toDate ? this.moment(this.toDate).format("YYYY-MM-DD") : "";
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/list?page=" +
            currentPage+
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=CANCEL_TRADER,CANCEL_ADMIN,CANCEL_CURVE,CANCEL_MIN_QUANTITY,CANCEL_DAILIY,CANCEL_YIELD_UPDATE,CANCEL_PENDING"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
            subId+
            "&userId="+
            userId+
            "&needAllCancelData=true"+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate,
            auth

        )
        .then(result => {
          console.log(result);
          this.loading = false;
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(bid) {
            bid.isCancel = false;
            bid.isActive = false;
            bid.yieldValueOperator = '+';
            bid.priceValueOperator = '+';
            if(bid.pointToCurve == 'MUNICURVE') bid.pointToCurve  = 'Muni Curve';
            if(bid.pointToCurve == 'TENYEARTREASURRY') bid.pointToCurve  = '10 Year Treasury';
          });
          this.bids = result.data.content;  
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBidDetails(bidSelected){
      this.bids.forEach(function(bid) {
        bid.isActive = false;
      });
      bidSelected.isActive = true;
      this.bidSelected = bidSelected;
    },
    reUpload(){
        var message = "Are you sure you want to reupload this bid?";

        this.$confirm(message).then(() => {
           this.createBid();
        });
    },
    createBid(){
        var pointToCurveOnReupload = null;
        if(this.selectedBid.pointToCurve == 'Muni Curve') pointToCurveOnReupload  = 'MUNICURVE';
        if(this.selectedBid.pointToCurve == '10 Year Treasury') pointToCurveOnReupload  = 'TENYEARTREASURRY';
        var dataTosend =  {
            cusipId : this.selectedBid.cusipId,
            traderCognitoSub : this.cognitoSub,
            quantity : Number(this.selectedBid.quantity),
            amount : Number(this.selectedBid.amount),
            bidValidity : Number(this.selectedBid.bidValidity),
            bidType   : this.selectedBid.bidType,
            minQuantity   : this.selectedBid.minQuantity,
            pointToDate : this.selectedBid.pointToDate,
            pointToCurve : pointToCurveOnReupload,
            factorRatio  : this.selectedBid.factorRatio,
            curveYield : this.selectedBid.curveYield,
            yieldSpread : this.selectedBid.yieldSpread ,
            minBps : this.selectedBid.minBps ,
            maxBps : this.selectedBid.maxBps,
            tmcPrice : this.selectedBid.tmcPrice ,
            bidKeepCancel : this.selectedBid.bidKeepCancel

          }
      this.loader = true;
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
              config.baseUrlBidSide + "/bid",
                dataTosend,
            auth
        )
        .then(() => {
          this.outStandingBid = null;
          this.selectedBid = null;
          this.getBidList(this.currentPage); 
            
        })
        .catch(() => {
            
        });

    },
    checkOutstandingBid(bid){
      this.loading = true;
      this.selectedBid = bid;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/bid/outstanding/list?cusipId="+
            this.selectedBid.cusipId,
          auth
        )
        .then(response => {
          this.outStandingBid = response.data;
          this.loading = false;
          if(!this.outStandingBid) this.reUpload();
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    cancelBidAndPlaceNewBid(){
      this.createBid();
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clearFilter(){
      this.filterTrader = null;
      this.getBidList(); 
    }
    
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
            roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
            roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            this.cognitoSub = authService.getUser().cognitoSub;
            this.fromDate = this.moment().format("MM-DD-YYYY");
            this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
            this.getBidList();
          }
        });
        
        
      }
    });

  }
   
  
};
</script>